import { jsxs, jsx } from 'react/jsx-runtime';
import { useResourceDataContextSafe } from '../../../../resource-detail/components/context/resourceDataContext.js';
import { DropdownItemIconContainer } from '@fabric-app/ui/components/DropdownMenu/Item';
import { ContextMenu } from '@fabric-app/ui/components/ContextMenu/ContextMenu';
import { useResourceUserPinToHomescreen } from '../../../../resource-pin/mutations/useMutationResourceUserPin.js';
import { IconPin } from '@fabric-app/icons/mobile';

const ContextItemPinToHome = () => {
  const { resource } = useResourceDataContextSafe();
  const { togglePin, pinLabel } = useResourceUserPinToHomescreen(resource);
  return /* @__PURE__ */ jsxs(ContextMenu.Item, {
    onSelect: togglePin,
    "data-testid": "item-context-menu-pin-to-home-button",
    children: [
      /* @__PURE__ */ jsx(DropdownItemIconContainer, {
        children: /* @__PURE__ */ jsx(IconPin, {})
      }),
      pinLabel
    ]
  });
};

export { ContextItemPinToHome };
//# sourceMappingURL=ContextItemPinToHome.js.map
